import React from "react";

const proximoPartidos = [
  {
    fecha: "2026-06-06T20:00:00",
    juego: "J1 | SAB 6",
    estadio: "Estadio Ciudad",
    equipoLocal: {
      nombre: "Quimsa",
      logo: "https://aaquimsa.com/escudos/quimsa.png",
    },
    equipoRival: {
      nombre: "Gimnasia CR",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
    },
  },
  {
    fecha: "2026-06-08T20:00:00",
    juego: "J2 | LUN 8",
    estadio: "Estadio Ciudad",
    equipoLocal: {
      nombre: "Quimsa",
      logo: "https://aaquimsa.com/escudos/quimsa.png",
    },
    equipoRival: {
      nombre: "Gimnasia CR",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
    },
  },
  {
    fecha: "2026-06-11T20:00:00",
    juego: "J3 | JUE 11",
    estadio: "Est. Socios Fundadores",
    equipoLocal: {
      nombre: "Quimsa",
      logo: "https://aaquimsa.com/escudos/quimsa.png",
    },
    equipoRival: {
      nombre: "Gimnasia CR",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
    },
  },
  {
    fecha: "2026-06-13T20:00:00",
    juego: "J4 | SAB 13",
    estadio: "Est. Socios Fundadores",
    equipoLocal: {
      nombre: "Quimsa",
      logo: "https://aaquimsa.com/escudos/quimsa.png",
    },
    equipoRival: {
      nombre: "Gimnasia CR",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
    },
  },
  {
    fecha: "2026-06-17T20:00:00",
    juego: "J5 | MIE 17",
    estadio: "Estadio Ciudad",
    nota: "Si es necesario",
    equipoLocal: {
      nombre: "Quimsa",
      logo: "https://aaquimsa.com/escudos/quimsa.png",
    },
    equipoRival: {
      nombre: "Gimnasia CR",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
    },
  },
  {
    fecha: "2026-06-20T20:00:00",
    juego: "J6 | SAB 20",
    estadio: "Est. Socios Fundadores",
    nota: "Si es necesario",
    equipoLocal: {
      nombre: "Quimsa",
      logo: "https://aaquimsa.com/escudos/quimsa.png",
    },
    equipoRival: {
      nombre: "Gimnasia CR",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
    },
  },
  {
    fecha: "2026-06-23T20:00:00",
    juego: "J7 | MAR 23",
    estadio: "Estadio Ciudad",
    nota: "Si es necesario",
    equipoLocal: {
      nombre: "Quimsa",
      logo: "https://aaquimsa.com/escudos/quimsa.png",
    },
    equipoRival: {
      nombre: "Gimnasia CR",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/thumb/1/10/Club_Gimnasia_y_Esgrima_logo.svg/1280px-Club_Gimnasia_y_Esgrima_logo.svg.png",
    },
  },
];

// Formato Google Calendar
const formatGoogleDate = (dateString, durationHours = 2) => {
  const start = new Date(dateString);
  const end = new Date(start.getTime() + durationHours * 60 * 60 * 1000);

  const pad = (n) => String(n).padStart(2, "0");

  const format = (date) =>
    `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(
      date.getUTCDate()
    )}T${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}00Z`;

  return {
    start: format(start),
    end: format(end),
  };
};

const Calendario = () => {
  // Descargar .ICS
  const generarICS = (partido) => {
    const fechaInicio = new Date(partido.fecha);

    const fechaFin = new Date(
      fechaInicio.getTime() + 2 * 60 * 60 * 1000
    );

    const pad = (num) => String(num).padStart(2, "0");

    const formatoICS = (fecha) =>
      `${fecha.getUTCFullYear()}${pad(
        fecha.getUTCMonth() + 1
      )}${pad(fecha.getUTCDate())}T${pad(
        fecha.getUTCHours()
      )}${pad(fecha.getUTCMinutes())}00Z`;

    const ics = `
BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${partido.equipoLocal.nombre} vs ${partido.equipoRival.nombre}
DTSTART:${formatoICS(fechaInicio)}
DTEND:${formatoICS(fechaFin)}
DESCRIPTION:Partido de Quimsa
END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([ics], {
      type: "text/calendar;charset=utf-8",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download = `${partido.equipoLocal.nombre}_vs_${partido.equipoRival.nombre}.ics`;

    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div className="container mx-auto py-10 px-4">
      <h1 className="text-3xl font-bold text-center mb-2 uppercase text-[#202C5A]">
        Próximos Partidos — La Liga Playoffs (Semifinal)
      </h1>

      <p className="text-center text-lg font-semibold mb-6">QUIMSA vs BOCA</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {proximoPartidos.map((partido, index) => {
          const quimsaEsLocal =
            partido.equipoLocal.nombre === "Quimsa";

          const bgColor = quimsaEsLocal
            ? "bg-red-600"
            : "bg-blue-600";

          const condicion = quimsaEsLocal
            ? "(Local)"
            : "(Visitante)";

          const { start, end } = formatGoogleDate(
            partido.fecha
          );

          const googleUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
            partido.equipoLocal.nombre +
              " vs " +
              partido.equipoRival.nombre
          )}&dates=${start}/${end}&details=${encodeURIComponent(
            "Partido de Quimsa"
          )}&sf=true&output=xml`;

          return (
            <div
              key={index}
              className="rounded-lg shadow-lg overflow-hidden bg-gray-200"
            >
              {/* HEADER */}
              <div
                className={`${bgColor} text-white text-center font-semibold p-3`}
              >
                <p className="text-sm uppercase tracking-wide mb-1">
                  {partido.juego}
                </p>

                <p>
                  {new Date(partido.fecha).toLocaleDateString(
                    "es-AR",
                    {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                    }
                  )}{" "}
                  - {condicion}
                </p>
              </div>

              {/* EQUIPOS */}
              <div className="w-full h-40 flex items-center">
                {/* LOCAL */}
                <div className="w-1/2 flex flex-col justify-center items-center p-2 bg-gray-100 h-full">
                  <img
                    src={partido.equipoLocal.logo}
                    alt={`Logo de ${partido.equipoLocal.nombre}`}
                    className="h-16 w-16 object-contain mb-2"
                  />

                  <p className="font-bold text-gray-800 text-lg text-center">
                    {partido.equipoLocal.nombre}
                  </p>

                  <p className="text-xs text-gray-600 font-semibold">
                    (LOCAL)
                  </p>
                </div>

                {/* VISITANTE */}
                <div className="w-1/2 flex flex-col justify-center items-center p-2 bg-gray-300 h-full">
                  <img
                    src={partido.equipoRival.logo}
                    alt={`Logo de ${partido.equipoRival.nombre}`}
                    className="h-16 w-16 object-contain mb-2"
                  />

                  <p className="font-bold text-gray-800 text-lg text-center">
                    {partido.equipoRival.nombre}
                  </p>

                  <p className="text-xs text-gray-600 font-semibold">
                    (VISITANTE)
                  </p>
                </div>
              </div>

              {partido.resultado && (
                <div className="px-4 pb-2">
                  <p className="text-sm text-green-700 font-bold text-center">
                    Resultado: {partido.resultado}
                  </p>
                </div>
              )}

              {/* BOTONES */}
              <div className="p-4 flex justify-center gap-3">
                <a
                  href={googleUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-semibold transition"
                >
                  📅 Google
                </a>

                <button
                  onClick={() => generarICS(partido)}
                  className="bg-gray-700 hover:bg-gray-800 text-white px-4 py-2 rounded-lg font-semibold transition"
                >
                  🍎 Apple / Outlook
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Calendario;